import { render } from "./GetInTouch.vue?vue&type=template&id=cfdc7986"
import script from "./GetInTouch.vue?vue&type=script&lang=js"
export * from "./GetInTouch.vue?vue&type=script&lang=js"

import "./GetInTouch.vue?vue&type=style&index=0&id=cfdc7986&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__